import axios from './../axios';
import util from './util';
const apiPath = 'api/admin/broadcast-records';

const broadcastApi = {
    index: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    },
    show: id => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/show/${id}`
        );
    },
    create: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/create`,
            { ...entity }
        );
    }
};

export default broadcastApi;
